export default {
  /**
   * Turns a phone string into a tel: link
   * @param  {STR} phone The phone number
   * @return {STR}       The linked phone number, or null
   */
  phoneLinkify (phone) {
    // Turn ext into a , which is used as the ext part in tel:
    let link = phone.replace(/ext/ig, ',')
    // Strip all other non numbers and comma
    link = link.replace(/[^0-9,]/g, '')
    // leave the last comma
    link = link.replace(/[,](?=.*[,])/g, '')

    return link ? 'tel:' + link : null
  }
}



// WEBPACK FOOTER //
// ./src/util.js